import React from 'react';
import type { LDFlagSet } from 'launchdarkly-js-client-sdk';

import { useFeatureFlags, User } from './useFeatureFlags';

type DecoratedProps<T> = T & {
	allFlags: LDFlagSet;
	updateUser: (u: Partial<User>) => Promise<void>;
};

/**
 * A higher order component that decorates the passed in component
 * and returns a new component with the added allFlags and updateUser props
 * to interact with the feature flag service
 */
export const withFeatureFlags = <T extends { [key: string]: unknown }>(
	Component: React.ComponentType<DecoratedProps<T>>
) => {
	const ComponentWithFlags = (props: T) => {
		const { allFlags, updateUser } = useFeatureFlags();
		return <Component {...props} allFlags={allFlags} updateUser={updateUser} />;
	};
	return ComponentWithFlags;
};
